/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
    EditButton,
    List,
    TextField,
    ReferenceField,
    DateField,
    NumberField,
} from 'react-admin'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import ListTitle from '../../components/ListTitle'
import Datagrid from '../../components/Datagrid/Datagrid'
import Filter from '../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)

export default function EOBIRateList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            sort={{ field: 'eobitype_id', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="EOBI Rate Setup" />
                <Datagrid {...props}>
                    <ReferenceField
                        source="eobitype_id"
                        reference="PY_EOBITypeTAB"
                    >
                        <TextField
                            label="EOBI Type"
                            headerClassName={classes.myHeader}
                            source="description"
                        />
                    </ReferenceField>
                    <DateField
                        label="Date WEF"
                        headerClassName={classes.myHeader}
                        source="date_wef"
                    />
                    <NumberField
                        label="Minimum Wage"
                        headerClassName={classes.myHeader}
                        source="minimum_wage"
                    />
                    <NumberField
                        label="Employer Contribution"
                        headerClassName={classes.myHeader}
                        source="employer_contribution"
                    />
                    <NumberField
                        label="Employee Contribution"
                        headerClassName={classes.myHeader}
                        source="employee_contribution"
                    />
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/PY_EOBIRateTAB"
                        />
                    ) : (
                        <EditButton basePath="/PY_EOBIRateTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

EOBIRateList.defaultProps = {
    quickSearch: false,
}
EOBIRateList.propTypes = {
    quickSearch: PropTypes.bool,
}
